import * as actionType from "../constants";
export const setNewStatus = (inputs) => async (dispatch) => {
  dispatch({ type: actionType.SET_NEW_STATUS_WORKFLOW, payload: inputs });
};
